import { up } from "inquirer/lib/utils/readline";

export default {
    route: {
        dashboard: "Home",
        i18n: "I18n",
        externalLink: "External Link",
        profile: "Profile",
        allCategories: "All Categories",
        homePage: "Home page",
        listGoods: "Product",
        BusinessListings: "Merchant List",
        beefMarket: "Cattle Breeds",
        industrynews: "News",
        helpCenter: "Help Center",
        community: "Community",
        liveCattle:'Live cattle'
    },
    navbar: {
        dashboard: "Dashboard",
        github: "Github",
        logOut: "Log Out",
        profile: "Profile",
        theme: "Theme",
        size: "Global Size",
        welcome: "Welcome to Glory Beef",
        register: "register",
        mfregister: "Free registration",
        shopHome: "Shop Home Page",
        myOrder: "My Order",
        memberCenter: "Membership Center",
        businessResidence: "Business Residence",
        businessBackground: "Business Background",
        shoppingCart: "Shopping Cart",
        signOut: "Sign out",
        followUs: "Scan and follow us",
        HourlyHotline: "Hourly service hotline",
        copyright: "copyright",
        LeshuiBay: "Glory Beef",
        footBot: "Yue ICP Bei No. 18070029",
        auction:"My Auction"
    },
    login: {
        title: "Login Form",
        logIn: "Login",
        username: "Username",
        password: "Password",
        any: "any",
        thirdparty: "Or connect with",
        thirdpartyTips:
            "Can not be simulated on local, so please combine you own business simulation! ! !",
        accountLogon: "Logon",
        notAccount: "Don't have an account yet?",
        registerNow: "Register Now",
        forgetPassword: "Forget password",
        return: "return",
        mailbox: "mailbox",
        checkingmailbox: "Verify email",
        inputLoginInfo: "Fill in account information",
        CompleteRegistration: "Complete registration",
        complete: "Complete",
        inputuser: "Please enter the user",
        inputpassWord: "Please input a password",

        verification: "Verification",
        newPassword: "New password",
        repeatNewPassword: "Repeat new password",
        clickVerify: "Click the button to verify",
        confirmPassword: "Confirm Password",
        registeredMailbox: "Registered Mailbox",
        mailboxCode: "Please enter your mailbox verification code",
        mailboxInput: "Please enter your email address",
        retrieve: "Retrieve",
        Consent: "Registered Representative Consent",
        getMailboxCode: "Get Mailbox Authentication Code",
        and: "and",
        fuwu: "《Service Terms》",
        yinsi: "《Privacy Policy》",
        Pleasepassword: "Please enter a new password",
        Pleaseagain: "Please enter the password again",
        loginsuccessful: "login was successful",
        Pleaselogin: "Please log in",
        Previousstep: "Previous step",
        nextstep: "next step"
    },
    permission: {
        addRole: "New Role",
        editPermission: "Edit",
        roles: "Your roles",
        switchRoles: "Switch roles",
        tips:
            "In some cases, using v-permission will have no effect. For example: Element-UI  el-tab or el-table-column and other scenes that dynamically render dom. You can only do this with v-if.",
        delete: "Delete",
        confirm: "Confirm",
        cancel: "Cancel"
    },
    table: {
        putTitle: "Please enter a title",
        putTitleLengh: "1 to 100 characters in length",
        putContext: "Please enter a topic",
        putContextLength: "1 to 1200 characters in length",
        selectPhotoView: "Please select image text or video text",
        dynamicTips1: "Fixed header, sorted by header order",
        dynamicTips2: "Not fixed header, sorted by click order",
        dragTips1: "The default order",
        dragTips2: "The after dragging order",
        title: "Title",
        importance: "Imp",
        type: "Type",
        remark: "Remark",
        search: "Search",
        add: "Add",
        export: "Export",
        reviewer: "reviewer",
        id: "ID",
        date: "Date",
        author: "Author",
        readings: "Readings",
        status: "Status",
        actions: "Actions",
        edit: "Edit",
        publish: "Publish",
        shenhe: "awaiting approval",
        hasPublished: "Published",
        reject: "rejected",
        draft: "Draft",
        delete: "Delete",
        cancel: "Cancel",
        confirm: "Confirm",
        completeImgs: "Please fill in the content",
    },
    excel: {
        export: "Export",
        selectedExport: "Export Selected Items",
        placeholder: "Please enter the file name (default excel-list)"
    },
    zip: {
        export: "Export",
        placeholder: "Please enter the file name (default file)"
    },
    pdf: {
        tips:
            "Here we use window.print() to implement the feature of downloading PDF."
    },
    theme: {
        change: "Change Theme",
        documentation: "Theme documentation",
        tips:
            "Tips: It is different from the theme-pick on the navbar is two different skinning methods, each with different application scenarios. Refer to the documentation for details."
    },
    tagsView: {
        refresh: "Refresh",
        close: "Close",
        closeOthers: "Close Others",
        closeAll: "Close All"
    },
    settings: {
        title: "Page style setting",
        theme: "Theme Color",
        tagsView: "Open Tags-View",
        fixedHeader: "Fixed Header",
        sidebarLogo: "Sidebar Logo"
    },
    // 公共
    common: {
        bookmark: "Bookmark",
        selfSupport: "Self-support",
        currentLocation: "Current Location",
        number: "Number",
        commodity: "commodity",
        specifications: "specifications",
        stock: "Stock",
        price: "Price",
        subtotal: "Subtotal",
        operation: "operation",
        unitPrice: "monovalent",
        TotalPrice: "Total price",
        delete: "delete",
        productCode: "Product code",
        beStock: "be out of stock",
        productSpecifications: "Product specifications",
        empty: "This place is empty",
        goodsOffShelf: "Goods are off shelf",
        outOfStock: "Out of stock",
        insufficientInventory: "Insufficient inventory",
        operation: "Operation",
        loading: "Loading",
        noItemSelected: "No item selected!",
        successCollection: "Successful collection",
        collectionCancelled: "Collection cancelled",
        default: "Default",
        isDeleteAddress: "Are you sure to delete the shipping address?",
        Tips: "Tips",
        SuccessDeleted: "Successfully deleted!",
        DeleteFailed: "Delete failed!",
        SuccessModified: "Successfully modified",
        date: "Date",
        createTime: "Create Time",
        updateTime: "Update Time",
        title:"Title",
        like:"Like",
        send:"send",
        contactUs:"ContactUs"
    },
    // 首页
    home: {
        merchants: "Merchants",
        hotSearches: "Popular Searches",
        HistoricalSearch: "Historical Search",
        viewMore: "View more",
        preferredMerchants: "Preferred Merchants",
        preferredMerchantsSubTit: "Good reputation shop, unlimited repurchase",
        HourServiceHotline: "Hour service hotline:"
    },
    // 商品详情页
    goodsDetail: {
        commodityDetailsPage: "Commodity Details Page",
        purchasePrice: "Purchase price",
        cumulativeSales: "Cumulative Sales",
        buyNow: "Buy now",
        bidNow: "Bid Now",
        addToCart: "Add to cart",
        commodityInfo: "commodity information",
        shoppingCartSucAdd: "Shopping cart successfully added"
    },
    // 商品列表
    goodsList: {
        allProducts: "All products",
        ProductList: "Product List",
        ProductScreening: "Product screening",
        itemsTotal: " items in total",
        common: "Common",
        selected: "You have selected",
        comprehensive: "comprehensive",
        salesvolume: "Sales Volume",
        price: "price",
        multipleChoice: "multiple Choice"
    },
    // 购物车
    shopCart: {
        cartEmpty: "Your shopping cart is empty",
        purchase: "Hurry up and make a purchase",
        recommended: "Recommended for you",
        deleteSelected: "Delete selected product",
        selected: "Selected",
        totalPrice: "Total price",
        toSettle: "To settle",
        settleProgress: "Settlement in progress",
        selectedItems1: "",
        selectedItems2: " items selected"
    },
    // 订单
    order: {
        TakeProduct: "Take a product",
        fillOrderInfo: "Fill in and verify order information",
        SuccessSubmittOrder: "Successfully submitted order",
        fillOrderInfo: "Fill in and verify order information",
        addAddress: "Add shipping address",
        defaultAddress: "Default Address",
        noAddress: "No address yet",
        moreAddresses: "More Addresses",
        receiveAddress: "Receive Address",
        goBrowsing: "Go browsing",
        ProductQuantity: "Product quantity",
        submit: "Submit",
        pleaseEnterContent: "Please enter content",
        addEditAddress: "Add/Edit Address",
        consignee: "consignee",
        pleaseEnterRecipient: "Please enter the recipient",
        contactNumber: "contact number",
        phoneNumber: "11 digit phone number",
        address: "Shipping address",
        default: "Set as default",
        save: "preservation",
        orderSuccessUpload:
            "The order has been submitted successfully. Please upload the payment voucher as soon as possible!",
        orderNumber: "orderNumber",
        TotalOrderAmount: " Total order amount",
        actualPayment: "Actual payment of goods",
        contactInfo: "contact information",
        uploadCredentials: "Pay",
        cancelOrder: "cancellation of order",
        cancel: "Cancel",
        determine: "Ok",
        cancelThisOrder: "Do you want to cancel this order",
        uncanceledOrders: "Uncanceled orders",
        canceledSuccess: "Canceled successfully",
        viewOrder: "view order",
        ViewAllOrders: "View All Orders",
        allOrders: "All orders",
        toBeUploaded: "Upload credentials",
        toBeShipped: "To be shipped",
        Audit: "Audit",
        toBeReceived: "To be received",
        completed: "Completed",
        shipped: "Shipped",
        viewDetails: "View Details",
        orderTime: "Order time ",
        orderAmount: "Total order amount",
        enterOrderNumber: "Please enter the order number",
        myOrder: "My Order",
        billingAccount: "Billing Account",
        addressee: "Addressee",
        orderRemarksInfo: "Order Remarks Information",
        noData: "No data at this time",
        ItemSKU: "shopSku",
        common: "common",
        Total: "Total ",
        yuan: " yuan",
        piece: "piece",
        tip1: "Order Acquisition Failed!",
        tip2: "Current order amount is 0, please continue purchasing!",
        tip3: "Order payment information is missing!",
        tip4: "Receipt address not filled in!",
        addressErr1: "Incorrect filling format",
        addressErr2: "Please enter the recipient's name!",
        addressErr3: "Please enter a valid recipient name!",
        addressErr4: "Please enter an 11 digit valid phone number!",
        addressErr5: "Please enter an 11 digit valid phone number!",
        addressErr6: "The phone number format is incorrect!",
        addressErr7: "Please enter an address!",
        addressErr8: "The detailed address is too long, please re-enter!",
        actualPayment: "Actual payment",
        totalPayment: "Total payment",
        orderStatus1:
            "Payment voucher has been uploaded and is pending review~",
        orderStatus2: "Review completed, awaiting shipment~",
        orderStatus3: "Shipped~",
        uploadVoucher: "Please upload the voucher",
        uploadSuccess: "Upload successful",
        orderNumber2:"Order Number",
        productName:"Product Name",
        purchaseTime:"Purchase time",
        seller:"seller",
        sellerPhone:"Seller phone",
        sellerEmail:"Seller email",
        sellerAddress:"Seller address",
        mode:"Mode",

    },
    // 个人中心
    profile: {
        address: "Address",
        myCollection: "My Collection",
        orderManagement: "Order management",
        goodsCollection: "Goods Collection",
        storeCollection: "Store Collection",
        cancelCollection: "Cancel Collection",
        created: "You have created ",
        receiptAddresses: " receipt Addresses,",
        upTo10: "up to ",
        ge: "",
        isCancelCol: "Are you sure to cancel the collection?",
        lookOther: "Look at something else",

        community: "personal community",
    },
    // 商户
    Merchant: {
        PeopleCollections: "collections",
        ComeLook: "Come",
        Favorite: "Favorite",
        CollectionStore: "Collection Store"
    },
    Settlein: {
        Storestatus: "Store status",
        Auditfailed: "Audit failed",
        Normaloperations: "Normal business operations",
        ViolatingClearance: "Violating customs clearance",
        username: "user name",
        email: "The email is the login email",
        ContactName: "Contact Name",
        phonenumber: "Contact phone number",
        StoreName: "Store Name",
        StoreIntroduction: "Store Introduction",
        Detailedaddress: "Detailed address",
        tips1:
            "Please upload the store logo, with a single photo size of no more than 2M, supporting jpg and png formats",
        Pleaselogo: "Please upload the store logo",
        storelogo: "Store Logo",
        Businesslicense: "Business license",
        tips2:
            "Please provide a business license, with a single photo size of no more than 2M, supporting jpg and png formats",
        PleaseLicense: "Please upload your business license",
        haveagree: "I have read and agree",
        MerchantAgreement: "Merchant Entry Agreement"
    },
    // 所有提示
    prompt: {
        passwordTips1: "Incorrect email format!",
        passwordTips2: "Obtain email verification code",
        passwordTips3: "Incorrect email format!",
        passwordTips4: "Please enter the email verification code!",
        passwordTips5: "Please input a password!",
        passwordTips6: "Password length 6-16 digits!",
        passwordTips7: "The two password entries do not match!"
    },
    community:{
        postTopic: "Welcome to post a topic",
        enterTitle:"Please enter a title",
        ImageText:"Image and text",
        viedoText: "Viedo and Text",
        title:"Title",
        content: "Content",
        rest:"Rest",
        release:"Release",
        fiveAll:"Up to 5 images",
        oneViedo:"Upload a maximum of one video, not exceeding 50MB",
        viedoUp:"Upload a viedo"
    }
};
